import { NgModule } from '@angular/core';
import { MeasurementTypeTranslationPipe } from './measurement-type-translation.pipe';

@NgModule({
  declarations: [MeasurementTypeTranslationPipe],
  exports: [MeasurementTypeTranslationPipe],
  providers: [MeasurementTypeTranslationPipe],
})
export class MessagesStoreSharedModule {}
